import { getLocationSearch } from 'modules/taboola-common-frontend-modules/query-params/queryParamUtils';
import { SET_LOCATION_SEARCH } from './actionTypes';

export const setLocationSearch = search => ({
    type: SET_LOCATION_SEARCH,
    payload: search || getLocationSearch(),
});
